import { useState } from "react";
import { FaArrowRight, FaEnvelope, FaLinkedinIn, FaMapMarkerAlt, FaXing } from "react-icons/fa";
import resumeData from "../../data/resumeData";

const Hero = () => {
  const [avatarError, setAvatarError] = useState(false);
  const { name, contact, profileImage, quickStats, currentlyExploring } = resumeData;

  return (
    <section id="about" className="portfolio-hero">
      <div className="hero-aura" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-5 pb-14 pt-12 sm:px-6 lg:px-8 lg:pt-20">
        <div className="grid items-center gap-12 lg:grid-cols-[1.2fr_0.8fr] lg:gap-16">
          <div className="min-w-0">
            <p className="hero-eyebrow">
              <span /> {resumeData.positioning}
            </p>
            <h1 className="hero-brand-name">{name}</h1>
            <p className="hero-headline">
              Enterprise platforms.
              <br />
              <span>Practical AI.</span>
            </p>
            <p className="mt-6 max-w-xl text-base leading-8 text-stone-600 dark:text-stone-400">
              {resumeData.introduction}
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a href="#experience" className="hero-primary">
                View experience <FaArrowRight size={14} />
              </a>
              <a href={`mailto:${contact.email}`} className="hero-secondary">
                Contact me <span aria-hidden="true">↗</span>
              </a>
            </div>
            <div className="mt-8 flex flex-wrap items-center gap-5 text-sm text-stone-600 dark:text-stone-400">
              <a
                href={contact.linkedin}
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
                className="hero-social"
              >
                <FaLinkedinIn size={18} />
              </a>
              <a href={contact.xing} target="_blank" rel="noreferrer" aria-label="Xing" className="hero-social">
                <FaXing size={18} />
              </a>
              <a href={`mailto:${contact.email}`} aria-label="Email Denzil" className="hero-social">
                <FaEnvelope size={18} />
              </a>
              <span className="inline-flex items-center gap-2 border-l border-stone-400/30 pl-5">
                <FaMapMarkerAlt />
                {contact.location}
              </span>
            </div>
          </div>

          <div className="hero-portrait-wrap">
            <div className="hero-portrait">
              {!avatarError ? (
                <img
                  src={profileImage}
                  alt={`${name}, senior software engineer based in Munich`}
                  onError={() => setAvatarError(true)}
                />
              ) : (
                <div className="flex aspect-[4/5] items-center justify-center text-7xl font-bold">DM</div>
              )}
            </div>
          </div>
        </div>

        <div className="hero-bottom-strip">
          <div className="max-w-md">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-teal-800 dark:text-teal-300">
              Currently exploring
            </p>
            <p className="mt-2 text-sm font-semibold text-stone-800 dark:text-stone-200">{currentlyExploring}</p>
            <p className="mt-3 text-sm leading-7 text-stone-600 dark:text-stone-400">
              {resumeData.title}. Experience across insurance, banking, and energy teams in Europe and India.
            </p>
          </div>
          <div className="grid grid-cols-3 gap-5 sm:gap-10">
            {quickStats.map((stat) => (
              <div key={stat.label}>
                <p className="text-2xl font-bold tracking-tight sm:text-3xl">{stat.value}</p>
                <p className="mt-2 max-w-[150px] text-xs leading-5 text-stone-500 dark:text-stone-400">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
